import axios from 'axios';
import { isAndroid, isIOS } from '@libs/utils/helpers/mobileOS';
import { MatchMakerPayload, MatchMakerResponseProps } from '../types';

export const useApiMM = (token?: string) => {
  const baseURL = import.meta.env['VITE_MATCH_MAKER_API'];

  const getDevice = (): string => {
    if (isAndroid()) return 'android';
    if (isIOS()) return 'ios';
    return 'web';
  };

  const matchRequest = async (data: MatchMakerPayload) => {
    const response = await axios.get<MatchMakerResponseProps>(`${baseURL}/v3/match`, {
      params: data,
      headers: {
        Device: getDevice(),
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  };

  return {
    matchRequest,
  };
};
